import React, { useState, useEffect, useContext } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Container } from 'reactstrap';

//constant
import { directUrl, homePageUrl } from '../../../helpers/Constants';

//assets
// import logo from "../../../assets/image/logo-black.webp";
import logo from "../../../assets/image/Logo3.svg";
import { userStore } from '../../../stores';
import { requestApi } from "../../../request-api";
import { GlobalContext } from '../../../contexts/GlobalContext';
import NotificationBadge from 'react-notification-badge';
import { Effect } from 'react-notification-badge';

function ApproverHeader(props) {
	const { notification, setNotification, roomId, setRoomId } = useContext(GlobalContext)

	let navigate = useNavigate()
	let { hideHeader } = props;
	const location = useLocation();
	let myLocation = location.pathname;
	//states
	let [isOpen, setIsOpen] = useState(false);
	const [user, setUser] = useState({});
	let userName = '';
	// const [notifications, setNotification] = useState();


	//Mobile menu  
	const toggle = () => {
		setIsOpen(!isOpen)
	}

	const logout = () => {
		localStorage.clear()
		navigate(`${directUrl}sign-in`)
	}
	const directToSetting = () => {
		navigate(`${directUrl}auditor/create-user-profile/settings`)
	}
	useEffect(() => {
		userData()
		getNotification()
		// console.log("get the notifcation ",notification)
	}, []);


	const userData = () => {
		requestApi(`/superadmin/userData`, {
			method: "get",
		}).then((data) => {
			if (data.statusCode === 200) {
				userName = data.data.name
				setUser(data.data)
				//   console.log("local storage::",user.name,data.data.name)
			} else {
			}
		})
			.catch((error) => {
				console.log("Error", error);
			});
	}

	const seenStatusActivityLog = (e, activity_id) => {
		e.preventDefault()
		requestApi(`/activity/changeSeenStatus/${activity_id}`, {
			method: "get",
		})
			.then((data) => {

			})
			.catch((error) => {
				console.log("Error", error);
			})
	}

	const getNotification = () => {
		requestApi(`/activity/approver/notification`, {
			method: "get",
		})
			.then((data) => {
				if (data.statusCode === 200) {
					setNotification(data.data)
					//   console.log("local storage111::",data.data)
				} else {
				}
			})
			.catch((error) => {
				console.log("Error", error);
			});
	};

	return (
		<>
			{!hideHeader && <header className='bs-header bs-head '>
				<Navbar expand="xl">
					<div className='navbar-outer'>
						<NavbarBrand href={`/approver/dashboard`}>
							{/* <img className='nav-logo' src={logo} alt='GLYPHER TECH LOGO' /> */}
							<img className='nav-logo' src={logo} alt='GLYPHER TECH LOGO' />
						</NavbarBrand>
						<NavbarToggler onClick={toggle} />
						<Collapse isOpen={isOpen} navbar>
							<Nav className="ml-auto " navbar>
								<NavItem>
									<NavLink className="nav-link first" exact to={`approver/dashboard`} style={{
											textDecoration: 'none',
											color: myLocation.includes('approver/dashboard') ? '#000' : '#555',
											fontWeight: myLocation.includes('approver/dashboard') ? 'bold' : 'normal',
										}}>Dashboard</NavLink>
								</NavItem>
								<NavItem>
									<NavLink className='nav-link' to={`approver/actionapprover`} style={{
											textDecoration: 'none',
											color: myLocation.includes('approver/actionapprover') ? '#000' : '#555',
											fontWeight: myLocation.includes('approver/actionapprover') ? 'bold' : 'normal',
										}}>Action</NavLink>
								</NavItem>

								<NavItem>
									<NavLink className={myLocation.includes('approver/view/legislation-list') || myLocation.includes('compliancer/view/legislation-list') ? 'nav-link active' : 'nav-link'} exact to={`approver/reports-approver`} style={{
											textDecoration: 'none',
											color: myLocation.includes('approver/reports-approvert') ? '#000' : '#555',
											fontWeight: myLocation.includes('approver/reports-approver') ? 'bold' : 'normal',
										}}>Reports</NavLink>
								</NavItem>
								{/* <NavItem>
									<NavLink className='nav-link' to={`approver/comments`}>COMMENTS</NavLink>
								</NavItem> */}

							</Nav>
							<Nav className="ml-auto navbar-right" navbar>
								{/* <UncontrolledDropdown className='user-drop' nav inNavbar>
									<DropdownToggle to={`notification`} nav caret>
										<NotificationBadge
											count={notification.length}
											effect={Effect.SCALE}
										/>
										<i className='icon icon-bell'></i>
									</DropdownToggle>
									<DropdownMenu className='notification' end>
										{notification != null ? notification.length > 0 ? (notification.map((noti) => {
											if (noti.chat_id != null) {
												return (
													<DropdownItem onClick={() => { setNotification(notification.filter((n) => n !== noti)); setRoomId(noti.chat_id); navigate(`${directUrl}approver/comments`) }} >You have message in  {noti.chat_id}</DropdownItem>
												)
											}
											else if (noti.approver_comments != null) {
												return (
													<DropdownItem onClick={(e) => { seenStatusActivityLog(e, noti.id); setNotification(notification.filter((n) => n !== noti)) }}>{noti.approver_comments}</DropdownItem>
												)
											}

										})) : <DropdownItem>{"No Notifications"}</DropdownItem> : <DropdownItem>{"No Notifications"}</DropdownItem>}
									</DropdownMenu>
								</UncontrolledDropdown> */}
								{/* <UncontrolledDropdown className='user-drop' nav inNavbar>
									<DropdownToggle to={`notifications`} nav caret>
										<i className='icon icon-bell'></i>
									</DropdownToggle>
									<DropdownMenu className='notification' right>
										{console.log('A===============>',notifications)}
										{notifications != null ? notifications.length >0?( notifications.map((noti)=>{
											if(noti.approver_comments != null){
												return(
													<DropdownItem >{noti.approver_comments}</DropdownItem>
												)
											}
											
										})):<DropdownItem>{"No Notifications"}</DropdownItem>:<DropdownItem>{"No Notifications"}</DropdownItem>}
									</DropdownMenu>
								</UncontrolledDropdown> */}
								{/* <UncontrolledDropdown nav inNavbar>
																	<DropdownToggle nav caret className="d-flex align-items-center">
																		<img
																			src="https://media.istockphoto.com/id/1223671392/vector/default-profile-picture-avatar-photo-placeholder-vector-illustration.jpg?s=612x612&w=0&k=20&c=s0aTdmT5aU6b8ot7VKm11DeID6NctRCpB755rA1BIP0="
																			alt="User"
																			style={{
																				width: '32px',
																				height: '32px',
																				borderRadius: '50%',
																				marginRight: '8px',
																				objectFit: 'cover',
																			}}
																		/>
																		<div className="d-none d-md-block text-start">
																			<div style={{ fontWeight: 'bold', fontSize: '14px' }}>{user.name}</div>
																			<div style={{ fontSize: '12px', color: '#777' }}>{user.email}</div>
																		</div>
																	</DropdownToggle>
																	<DropdownMenu end>
																		<DropdownItem disabled>Hi, {user.name}</DropdownItem>
																		<DropdownItem divider />
																		<DropdownItem onClick={logout}>Log Out</DropdownItem>
																	</DropdownMenu>
																</UncontrolledDropdown> */}
								<UncontrolledDropdown className='user-drop' nav inNavbar>
									<DropdownToggle nav caret className="d-flex align-items-center">
																		<img
																			src="https://media.istockphoto.com/id/1223671392/vector/default-profile-picture-avatar-photo-placeholder-vector-illustration.jpg?s=612x612&w=0&k=20&c=s0aTdmT5aU6b8ot7VKm11DeID6NctRCpB755rA1BIP0="
																			alt="User"
																			style={{
																				width: '32px',
																				height: '32px',
																				borderRadius: '50%',
																				marginRight: '8px',
																				objectFit: 'cover',
																			}}
																		/>
																		<div className="d-none d-md-block text-start">
																			<div style={{ fontWeight: 'bold', fontSize: '14px' }}>{user.name}</div>
																			<div style={{ fontSize: '12px', color: '#777' }}>{user.email}</div>
																		</div>
																	</DropdownToggle>
									
									<DropdownMenu end>
										<DropdownItem>Hi, {user.name}</DropdownItem>
										{/* <DropdownItem onClick={directToSetting}>Edit Profile</DropdownItem> */}
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
									</DropdownMenu>
								</UncontrolledDropdown>
							</Nav>
						</Collapse>
					</div>
				</Navbar>
			</header>}
		</>
	)
}

export default ApproverHeader
